<template>
  <div>
  
    <b-navbar toggleable="lg" type="dark" variant="primary" class="font-weight-bold">

      <b-navbar-brand :to="{name: 'Dashboard'}" class="navbar-brand">
      <img src="@/assets/logo_full_white.png" class="d-inline-block align-left logo" alt="Logo ICDL"/>
      </b-navbar-brand>
          <b-nav-text class="text-white d-none d-sm-block">
            {{ fullName }}
          </b-nav-text>
      <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>

      <b-collapse id="nav-collapse" is-nav>
        <b-navbar-nav class="ml-auto">
          <b-nav-item :to="{name: 'Dashboard'}">
            <b-icon icon="house-fill"></b-icon>
            <span class="text-light">Mon tableau de bord</span>
          </b-nav-item>
          
          <b-nav-item-dropdown v-if="displayDcCertificateLink && displayDcplusCertificateLink" left>
            <template #button-content>
              <b-icon icon="award-fill"></b-icon> <span class="text-light">Mes certificats</span>
            </template>

            <b-dropdown-item :to="{name: 'Certificate', params: { user: userId }}" target="_blank" v-on:click.prevent="toggleModalIdentityDisplay" v-if="identityModalStep!=null">
              <span class="font-weight-bold">Digital Citizen</span>
            </b-dropdown-item>
            <b-dropdown-item :to="{name: 'Certificate', params: { user: userId }}" target="_blank" v-on:click.prevent="$refs.icdlSurveyModal.showModal()" v-else-if="loadedIcdlSurvey==true && nbModulesCompleted>=nbModulesCompletedBeforeIcdlSurvey && checkedIdentity==true && icdlSurveyToDisplay.length>0 && !loadedCertificate">
              <span class="font-weight-bold">Digital Citizen</span>
            </b-dropdown-item>
            <b-dropdown-item :to="{name: 'Certificate', params: { user: userId }}" target="_blank" v-else>
              <span class="font-weight-bold">Digital Citizen</span>
            </b-dropdown-item>
            <b-dropdown-item :to="{name: 'DcplusCertificate', params: { user: userId }}" target="_blank">
              <span class="font-weight-bold">Digital Citizen Plus</span>
            </b-dropdown-item>
          </b-nav-item-dropdown>
          <template v-else-if="displayDcCertificateLink">
            <b-nav-item :to="{name: 'Certificate', params: { user: userId }}" target="_blank" v-on:click.prevent="toggleModalIdentityDisplay" v-if="identityModalStep!=null">
              <b-icon icon="award-fill"></b-icon>
              <span class="text-light">Mon certificat</span>
            </b-nav-item>
            <b-nav-item :to="{name: 'Certificate', params: { user: userId }}" target="_blank" v-on:click.prevent="$refs.icdlSurveyModal.showModal()" v-else-if="loadedIcdlSurvey==true && nbModulesCompleted>=nbModulesCompletedBeforeIcdlSurvey && checkedIdentity==true && icdlSurveyToDisplay.length>0 && !loadedCertificate">
              <b-icon icon="award-fill"></b-icon>
              <span class="text-light">Mon certificat</span>
            </b-nav-item>
            <b-nav-item :to="{name: 'Certificate', params: { user: userId }}" target="_blank" v-else>
              <b-icon icon="award-fill"></b-icon>
              <span class="text-light">Mon certificat</span>
            </b-nav-item>
          </template>
          <b-nav-item :to="{name: 'Infos' }">
            <b-icon icon="person-fill"></b-icon>
            <span class="text-light">Mes informations</span>
          </b-nav-item>
          <b-nav-item @click="logout" v-b-hover="handleHover">
            <span :class="isHovered ? 'text-danger' : 'text-light'">
              <b-icon icon="power" variant="danger"></b-icon>
              Déconnexion
            </span>
          </b-nav-item>
        </b-navbar-nav>
      </b-collapse>
    </b-navbar>

    <identity-modal ref="identityModal"></identity-modal>

    <icdl-survey-modal ref="icdlSurveyModal"></icdl-survey-modal>

    <div class="bg-view bg-primary">
      <b-container id="view-container" class="container bg-light" fluid="lg" variant="light" type="light">
        <b-overlay :show="loading" spinner-variant="primary" opacity="0.95">
          <template #overlay>
            <!-- Compense un déclage du spinner et texte de l'overlay sur les page Dashboard et Course -->
            <div v-if="$route.name=='Dashboard'" style="height:50px"></div>
            <div v-else-if="$route.name=='Course'" style="height:100px"></div>
            <div class="text-center">
              <b-spinner variant="primary" label="Spinning"></b-spinner>
              <h5 id="loading-label" class="mt-3">{{ loadingText }}</h5>
            </div>
          </template>
          <router-view id="router-view"> </router-view>
        </b-overlay>
      </b-container>
    </div>
    
    <b-alert 
      id="main-alert" 
      class="position-fixed" 
      :show="alert.dismissCountdown"
      fade 
      dismissible
      :variant="alert.variant"
      @dismissed="alert.dismissCountDown=0"
      @dismiss-count-down="countdownChanged"
    >{{ alert.text }}</b-alert>
  </div>
</template>

<script>
import Store from '@/store/index.js'
import IdentityModal from '../components/IdentityModal.vue'
import IcdlSurveyModal from '../components/IcdlSurveyModal.vue'
import surveyApi from '@/services/survey.js'

export default {
  components: {
    IdentityModal,
    IcdlSurveyModal
  },
  methods: {
    logout() {
      Store.dispatch('auth_logout')
    },
    setLoading(loading, text="Chargement...") {
      this.loading = loading
      this.loadingText = (loading == true)? text : ""
    },
    handleHover(hovered) {
      this.isHovered = hovered
    },
    toggleModalIdentityDisplay() {
      this.$refs.identityModal.toggleModal()
    },
    countdownChanged(dismissCountdown) {
      this.alert.dismissCountdown = dismissCountdown
    },
    showAlert(text, variant) {
      this.alert.variant = variant;
      this.alert.text = text;
      this.alert.dismissCountdown = this.alert.dismissSecs
    },
    async getProfileSurvey() {
      this.loadedProfileSurvey=false;
      this.profileSurveyToDisplay=[];
      await surveyApi.get("/question/progress/"+this.surveyStep)
      .then(response => {
        this.profileSurvey = response.data[0]['questions'];
        this.userProfileSurveyResponses = response.data[0]['responses'];
        this.profileSurvey.forEach(el => {
          el.proposals.sort((a,b) => a.order-b.order)
          if (el.type == 'radio') {
            let response = this.userProfileSurveyResponses.find(resp => resp.proposal.survey.id==el.id)
            if(response !== undefined) {
              el['checked'] = response.proposal.id
              el['alreadyAnswered'] = true
            }
            else {
              el['checked'] = null
              el['alreadyAnswered'] = false
            }
          }
          else if (el.type == 'checkbox') {
            el['checked'] = [];
            el.proposals.forEach(prop => {
              let response = this.userProfileSurveyResponses.find(resp => resp.proposal.id==prop.id)
              if (response !== undefined) {
                el['checked'].push(prop.id)
              }
            })
            if(el.checked.length>0) {
              el['alreadyAnswered'] = true
            }
            else {
              el['alreadyAnswered'] = false
            }
          }
          else if (el.type == 'text') {
            el.proposals.forEach(prop => {
              let response = this.userProfileSurveyResponses.find(resp => resp.proposal.id==prop.id)
              if (response !== undefined) {
                prop['value'] = response.free_field
                el['alreadyAnswered'] = true
              }
              else {
                el['alreadyAnswered'] = false
              }
            })
          }
          if(this.isAllowedToDisplay(el, "profile") == true) {
            this.profileSurveyToDisplay.push(el.id);
          }

        })
      })
      this.loadedProfileSurvey=true;
    },
    async getIcdlSurvey() {
      await surveyApi.get("/question/progress/4")
      .then(response => {
        this.icdlSurvey = response.data[0]['questions'];
        this.userIcdlSurveyResponses = response.data[0]['responses'];
        this.icdlSurvey.forEach(el => {
          el.proposals.sort((a,b) => a.order-b.order)
          if (el.type == 'radio') {
            let response = this.userIcdlSurveyResponses.find(resp => resp.proposal.survey.id==el.id)
            if(response !== undefined) {
              el['checked'] = response.proposal.id
              el['alreadyAnswered'] = true
              let proposal = el.proposals.find(prop => prop.id==response.proposal.id)
              proposal["freeFieldValue"] = (response.proposal.free_field==true) ? response.free_field : ""
            }
            else {
              el['checked'] = null
              el['alreadyAnswered'] = false
            }
          }
          else if (el.type == 'checkbox') {
            el['checked'] = [];
            el.proposals.forEach(prop => {
              let response = this.userIcdlSurveyResponses.find(resp => resp.proposal.id==prop.id)
              if (response !== undefined) {
                el['checked'].push(prop.id)
                prop["freeFieldValue"] = response.free_field
              }
            })
            if(el.checked.length>0) {
              el['alreadyAnswered'] = true
            }
            else {
              el['alreadyAnswered'] = false
            }
          }
          else if (el.type == 'text') {
            el.proposals.forEach(prop => {
              let response = this.userIcdlSurveyResponses.find(resp => resp.proposal.id==prop.id)
              if (response !== undefined) {
                prop['value'] = response.free_field
                el['alreadyAnswered'] = true
              }
              else {
                el['alreadyAnswered'] = false
              }
            })
          }
          if(this.isAllowedToDisplay(el, "icdl") == true && !el.alreadyAnswered) {
            this.icdlSurveyToDisplay.push(el.id);
          }

        })
      })
      this.loadedIcdlSurvey=true;
    },
    isAllowedToDisplay(surveyQuestion, surveyStep) {
      if (surveyQuestion.triggered_by.length<1) {
        return true
      }
      else {
        let show = false
        let survey = ""
        if (surveyStep == "profile") {
          survey = this.profileSurvey
        }
        else if (surveyStep == "icdl") {
          survey = this.icdlSurvey
        }
        else {
          return false
        }
        surveyQuestion.triggered_by.forEach(el => {
          let question = survey.find(surveyQuestion => surveyQuestion.id==el.survey.id)
          if((el.survey.type=="radio" && question.checked == el.id) || el.survey.type=="checkbox" && question.checked.includes(el.id)) {
            show = true;
          }
        });
        return show
      }
    },
    updateSurveyToDisplay(surveyToUpdate) {
      let newList=[];
      let survey=[];
      if(surveyToUpdate=="profile") {
        survey = this.profileSurvey
      }
      else if(surveyToUpdate=="icdl") {
        survey = this.icdlSurvey
      }
      else {return}
      survey.forEach(el => {
        if(this.isAllowedToDisplay(el, "profile") == true) {
          newList.push(el.id)
        }
        else {
          if (el.type == 'radio') {
            el['checked'] = null
            el['alreadyAnswered'] = false
          }
          else if (el.type == 'checkbox') {
            el['checked'] = [];
            el['alreadyAnswered'] = false
          }
          else if (el.type == 'text') {
            el.proposals.forEach(prop => {
              let response = this.userProfileSurveyResponses.find(resp => resp.proposal.id==prop.id)
              if (response !== undefined) {
                prop['value'] = ""
                el['alreadyAnswered'] = false
              }
            })
          }
        }
      })
      
      if(surveyToUpdate=="profile") {
        this.profileSurveyToDisplay=newList;
      }
      else if(surveyToUpdate=="icdl") {
        this.icdlSurveyToDisplay=newList;
      }
    },
  },
  data () {
    return {
      fullName: Store.getters.getFullName(),
      loading: false,
      loadingText: "Chargement...",
      isHovered: false,
      alert: {
        text:"",
        variant:"primary",
        dismissSecs: 5,
        dismissCountdown: 0,
      },
      nbModulesCompletedBeforeIcdlSurvey: 3,
      profileSurvey: [],
      userProfileSurveyResponses: [],
      icdlSurvey: [],
      userIcdlSurveyResponses: [],
      loadedProfileSurvey: false,
      loadedIcdlSurvey: false,
      profileSurveyToDisplay: [],
      icdlSurveyToDisplay: [],
      surveyStep: 1,
    }
  },
  created() {
    if(this.answeredSurveyAgreement != null) {
      let surveyAgreementDate = new Date(Store.getters.getDateAccordSondage())
      surveyAgreementDate.setHours(0,0,0,0);
      let sixMonthsAfterAgreementDate = surveyAgreementDate.setMonth(surveyAgreementDate.getMonth()+6)
      let oneYearAfterAgreementDate = surveyAgreementDate.setMonth(surveyAgreementDate.getMonth()+6)
      let now = new Date();
      
      if(now - oneYearAfterAgreementDate >= 0) {
        this.surveyStep = 5
      }
      else if (now - sixMonthsAfterAgreementDate >= 0) {
        this.surveyStep = 2
      }
    }
    else {
      this.surveyStep = 1
    }
    this.getProfileSurvey();
    this.getIcdlSurvey();
  },
  computed: {
    displayDcCertificateLink() {return Store.getters.getDisplayDcCertificateLink()},
    displayDcplusCertificateLink() {return Store.getters.getDisplayDcplusCertificateLink()},
    userId() {return Store.getters.getUserId()},
    identityModalStep() {return Store.getters.getCheckIdentityStep()},
    showMainAlert() {return this.alert.dismissCountdown},
    nbModulesCompleted() {return parseInt(Store.getters.getNbModulesCompleted())},
    checkedIdentity() {return Store.getters.getCheckedIdentity()},
    loadedCertificate() {return (this.$refs.icdlSurveyModal.certificateOnLoading) ? false : true},
    answeredSurveyAgreement() {return Store.getters.getDateAccordSondage() != "null"},
    profileSurveyProgress() {
      if(this.loadedProfileSurvey && this.profileSurvey.length > 0) {
        let nbResponse = 0;
        this.profileSurvey.forEach(el => {
          if ( (el.type == 'radio' && el.checked != null) || ((el.type == 'checkbox' && el.checked.length > 0)) ) {
            nbResponse++;
          }
          else if (el.type == 'text') {
            el.proposals.forEach(prop => {
              if (prop.value != null && prop.value != "") {
                nbResponse++;
              }
            })
          }
        })

        if(this.surveyStep == 1) {
          if( Store.getters.getDateAccordSondage() != 'null') {
            nbResponse++;
          }
  
          return 100 / (this.profileSurveyToDisplay.length +1) * nbResponse
        }
        else {
          return 100 / (this.profileSurveyToDisplay.length) * nbResponse
        }
      }
      else {
        return 0
      }
    }
  }
  
}
</script>

<style>
 #main-alert {
  top: 15px;
  right: 30px;
  height: 3rem;
  z-index:999999;
 }

.navbar-brand {
  font-weight: 500;
}

.logo {
  height: 3.5rem;
}

.navbar {
  padding: 1rem;
  margin-bottom: 30px;
}

#nav {
  padding: 30px;
}

#nav a {
  font-weight: bold;
  color: #2c3e50;
}

#nav a.router-link-exact-active {
  color: #42b983;
}

#view-container {
  padding:20px;
  border: #eee solid 1px;
  border-radius: 10px;
  min-height: 200px;
}
.bg-view {
  padding-bottom: 3em;
}
</style>
